import { useTranslation } from 'react-i18next';
import { STATUS_COLORS, type StatusKey } from '../../config/designTokens';

interface StatusBadgeProps {
  status: StatusKey;
  className?: string;
}

export default function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation();

  const colors = STATUS_COLORS[status] ?? STATUS_COLORS.unknown;

  const label = t(`status.${status}`, { defaultValue: status });
  const tooltip = t(`status.tooltip.${status}`, { defaultValue: '' });

  return (
    <span
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        borderColor: colors.border,
      }}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border cursor-help${className ? ` ${className}` : ''}`}
      title={tooltip || undefined}
    >
      {label}
    </span>
  );
}
